import ConfirmReset from "./ConfirmReset";

export default ConfirmReset;